export const CHARTING_WORKSPACE_VIEW_MODES = ['chart', 'table'];
export const DEFAULT_CHARTING_WORKSPACE_VIEW_MODE = 'chart';

export function normalizeChartingWorkspaceViewMode(value) {
    return CHARTING_WORKSPACE_VIEW_MODES.includes(value) ? value : DEFAULT_CHARTING_WORKSPACE_VIEW_MODE;
}
